module.exports = __webpack_public_path__ + "static/img/banner_02.65c9a94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner_02.png
// module id = K/9t
// module chunks = 1